import { Provider } from '@angular/core';
import { TitleStrategy } from '@angular/router';
import { CustomTitleStrategy } from '../strategies/custom-title-strategy';

export const provideCustomTitleStrategyConfig = (): Provider => ({
  provide: TitleStrategy,
  useClass: CustomTitleStrategy,
});
